/* @flow */
import React from 'react';
import Button from 'components/Button.jsx';
import DeviceActions from 'actions/DeviceActions';
import ToastActions from 'actions/ToastActions';
import Form from 'components/Form.jsx';
import SettingsContainer from './SettingsContainer.jsx';
import FormInput from 'components/FormInput.jsx';
import AddButton from 'components/AddButton.jsx';
import CurrentUser from 'auth/CurrentUser';
import User from 'entities/User';
import EmailMergeConfirmation from 'user/components/EmailMergeConfirmation.jsx';
import { mountModal } from 'lib/modal';
import './styles/NewEmailDeviceForm.scss';

type State = {
  user: User,
  isEnteringEmail: boolean,
  hasChanged: boolean,
  canSubmit: boolean,
  errorMessage: string,
  code: string,
  enteredEmail: string,
};

const EXISTING_EMAIL_ERROR = 'email_exists';
const EVENT_SCREEN_NAME = 'settings_page';

const NewEmailDeviceForm = React.createClass({
  getInitialState(): State {
    return {
      user: CurrentUser.getUser(),
      isEnteringEmail: false,
      hasChanged: false,
      canSubmit: false,
      errorMessage: '',
      code: '',
      enteredEmail: '',
    };
  },

  renderEmailMergeConfirmation() {
    return (
      <EmailMergeConfirmation
        oldUserEmail={this.state.enteredEmail}
        errorMessage={this.state.errorMessage}
        eventScreenName={EVENT_SCREEN_NAME}
        onDone={DeviceActions.loadDevices}
      />
    );
  },

  onAddSuccess(response: *) {
    const label = response.getLabel ? response.getLabel() : response.getEmail();
    this.setState({ isEnteringEmail: false, errorMessage: '' });
    ToastActions.showSuccessToast(`${label} added`);
  },

  onAddError(error: *) {
    let errorMessage;

    if (error.field_errors) {
      errorMessage = error.field_errors.map(
        fieldError => fieldError.messages.join(', ')
      ).join(', ');
    } else {
      // DeviceActions.newEmailDevice return deprecated validation
      errorMessage = error.message;
    }

    this.setState({ errorMessage });

    if (error.code === EXISTING_EMAIL_ERROR) {
      mountModal(this.renderEmailMergeConfirmation(), this);
      this.setState({ isEnteringEmail: false, errorMessage: '', enteredEmail: '' });
    }
  },

  handleAddButtonClick() {
    this.setState({ isEnteringEmail: true });
  },

  handleCancelButtonClick() {
    this.setState({ isEnteringEmail: false, errorMessage: '', enteredEmail: '' });
  },

  handleSaveButtonClick({ email }: {email: string}) {
    this.setState({ isEnteringEmail: false, errorMessage: '', enteredEmail: email });
    DeviceActions.newEmailDevice(email).then(
      this.onAddSuccess,
      this.onAddError
    );
  },

  enableChanged() {
    this.setState({ hasChanged: true, errorMessage: '' });
  },

  disableButton() {
    this.setState({ canSubmit: false });
  },

  enableButton() {
    if (this.state.hasChanged) {
      this.setState({ canSubmit: true });
    }
  },

  render() {
    return (
      <Form
        key={this.state.user.cid}
        onChange={this.enableChanged}
        onValid={this.enableButton}
        onValidSubmit={this.handleSaveButtonClick}
        onInvalid={this.disableButton}>
        <SettingsContainer
          className="NewEmailDeviceForm">
          {this.state.isEnteringEmail ?
            <div>
              <div className="NewEmailDeviceForm-addEmail">
                <FormInput
                  className="NewEmailDeviceForm-addEmailInput"
                  name="email"
                  type="email"
                  validations="isEmail"
                  placeholder="Enter an email address"
                  autofocus
                />
              </div>
              <Button
                className="NewEmailDeviceForm-save"
                size="small"
                type="submit"
                disabled={!this.state.canSubmit}
                eventElementName="NewEmailDeviceForm-save">
                Save
              </Button>
              <Button
                className="NewEmailDeviceForm-cancel"
                size="small"
                onClick={this.handleCancelButtonClick}
                level="secondary"
                eventElementName="NewEmailDeviceForm-cancel">
                Cancel
              </Button>
            </div> :
            <AddButton
              size="large"
              className="NewEmailDeviceForm-addEmail"
              onClick={this.handleAddButtonClick}>
              Add an email address
            </AddButton>
          }
        </SettingsContainer>
      </Form>
    );
  },
});

export default NewEmailDeviceForm;



// WEBPACK FOOTER //
// ./src/settings/components/NewEmailDeviceForm.jsx